// extracted by mini-css-extract-plugin
export var container = "FCQCaseStudy-module--container--0bf78";
export var imageHolder = "FCQCaseStudy-module--image-holder--06855";
export var link = "FCQCaseStudy-module--link--54b68";
export var typographies = "FCQCaseStudy-module--typographies--c58f3";